<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" height="600" scrollable>
    <v-card v-if="classData.id">
      <v-card-title class="primary white--text">
        Hồ SƠ CHI TIẾT LỚP
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="dialog = false">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="mt-4">
          <v-col class="py-0 pr-14" cols="12">
            <v-row>
              <v-col class="d-flex align-center py-0" cols="12">
                <v-subheader class="px-0">Tên lớp</v-subheader>
                <p class="mb-0">{{ classData.title }}</p>
              </v-col>
              <v-col class="d-flex align-center py-0" cols="12">
                <v-subheader class="px-0">Khối</v-subheader>
                <p class="mb-0">{{ classData.grade | _get('title') }}</p>
              </v-col>
              <v-col class="d-flex align-center py-0" cols="12">
                <v-subheader class="px-0">Môn</v-subheader>
                <p class="mb-0">{{ classData.extraSubject && classData.extraSubject.title }}</p>
              </v-col>
              <v-col class="d-flex align-center py-0" cols="12">
                <v-subheader class="px-0">GVCN / phụ trách</v-subheader>
                <p class="mb-0">{{ getTeachers }}</p>
              </v-col>
              <v-col class="d-flex align-center py-0" cols="12">
                <v-subheader class="px-0">Sĩ số</v-subheader>
                <p class="mb-0">{{ getStudentCount }}</p>
              </v-col>
              <v-col class="d-flex align-center py-0" cols="12">
                <v-subheader class="px-0">Ghi chú</v-subheader>
                <p class="mb-0">{{ classData.description }}</p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="editState" class="ma-2" outlined color="#0D47A1">Sửa hồ sơ lớp</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { get } from 'lodash'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    state: Boolean,
    classData: Object
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    editState() {
      this.$emit('edit')
      this.dialog = false
    }
  },
  computed: {
    ...mapGetters('classDetail', ['teachings']),

    getStudentCount() {
      return get(this.classData.students, 'length', 0)
    },
    getTeachers() {
      if (this.teachings && this.teachings.length > 1) {
        let teacher = ''
        this.teachings.map(t => {
          if (t.teacher && t.teacher.name) teacher += t.teacher.name + ', '
        })
        return teacher || 'Không có'
      } else {
        return get(this.teachings[0], 'teacher.name', 'Không có')
      }
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  },
  filters: {
    getTeacher(data) {
      if (!data || !data.length) return 'không có'
      else return data[0].name
    }
  }
}
</script>

<style>
p {
  color: black;
}
.v-subheader {
  width: 30%;
}
</style>
